{
  "customFonts": [
    {
      "family": "Plain",
      "variants": [
        { "weight": 100, "style": "normal", "src": "/fonts/suri/Plain Thin.otf" },
        { "weight": 200, "style": "normal", "src": "/fonts/suri/Plain Ultralight.otf" },
        { "weight": 300, "style": "normal", "src": "/fonts/suri/Plain Light.otf" },
        { "weight": 400, "style": "normal", "src": "/fonts/suri/Plain Regular.otf" },
        { "weight": 500, "style": "normal", "src": "/fonts/suri/Plain Medium.otf" }
      ],
      "fallback": "sans-serif"
    }
  ]
}
